export default __webpack_public_path__ + "static/media/404.495d4b0c.png";